export default "__VITE_ASSET__DwdC$c0j__"